import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { HiPlus } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { alertDanger, alertNULL, alertSuccess } from "../context/actions/alertActions";
import { addNewToCart, setCartItems } from "../context/actions/cartActions";
import { addNewItemToCart, addNewItemToCartStaff, getAllCartItems, getCartFromStaff } from "../api";
import NotFound from "../assets/img/NotFound.svg";

const RowContainer = ({ flag, data, scrollValue }) => {
  const rowContainer = useRef();
  const user = useSelector((state) => state.user);
  const orderNumber = useSelector(state => state.cart.selectedCart)
  const dispatch = useDispatch();

  const AnimationImageItemsToCart = (productIdKey) => {
    const element = document.getElementById(productIdKey.toString());
    const shoppingBasket = document.getElementById("ShoppingBasket");

    if (element && shoppingBasket) {
      const imgTag = element.querySelector("img");

      if (imgTag.complete) {
        const imgCopy = imgTag.cloneNode(true);
        imgCopy.style.position = "absolute";

        const imgRect = imgTag.getBoundingClientRect();
        imgCopy.style.top = `0px`;
        imgCopy.style.left = `0px`;
        imgCopy.style.zIndex = "1000";

        imgTag.parentNode.appendChild(imgCopy);

        const translateX = shoppingBasket.getBoundingClientRect().left - imgRect.left;
        const translateY = shoppingBasket.getBoundingClientRect().top - imgRect.top;

        imgCopy.style.animation = `moveToBasket 3s forwards`;

        const styleElement = document.createElement("style");
        styleElement.innerHTML = `
          @keyframes moveToBasket {
            0% {
              transform: translate(0, 0) scale(1);
            }
            100% {
              transform: translate(${translateX}px, ${translateY - window.innerHeight}px) scale(0);
            }
          }
        `;

        imgCopy.addEventListener("animationend", () => {
          imgCopy.parentNode.removeChild(imgCopy);
        });
        document.head.appendChild(styleElement);
      } else {
        imgTag.onload = () => {
          AnimationImageItemsToCart(productIdKey);
        };
      }
    }
  };

  const addToCart = async (item) => {
    try {
      if (user?.role === "Staff") {
        dispatch(alertSuccess("Đã thêm vào giỏ hàng"));
        dispatch(addNewToCart(item))
        await addNewItemToCartStaff(user?.user_id, item, orderNumber)
        // const items = await getCartFromStaff(user?.user_id, orderNumber);
        // dispatch(setCartItems(items.data));
      } else {
        await addNewItemToCart(user?.user_id, item);
        dispatch(alertSuccess("Đã thêm vào giỏ hàng"));
        const items = await getAllCartItems(user?.user_id);
        dispatch(setCartItems(items));
      }

      setTimeout(() => {
        dispatch(alertNULL());
      }, 3000);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    rowContainer.current.scrollLeft += scrollValue;
  }, [scrollValue]);

  return (
    <div
      ref={rowContainer}
      className={`w-full drop-shadow-xl flex items-center md:gap-3 md:my-12 scroll-smooth ${flag ? "scrollbar-none" : "flex-wrap justify-center"
        }`}
    >
      {data && data.length > 0 ? (
        data.map((item) => (
          <div
            key={item?.product_id}
            id={item?.product_id}
            className="w-full h-[175px] min-w-[275px] md:w-300 md:min-w-[300px] bg-cardOverlay rounded-lg py-2 px-4 my-2 md:my-12 backdrop-blur-lg hover:drop-shadow-lg flex flex-col items-center justify-evenly relative"
          >
            <div className="w-full flex items-center justify-between">
              <motion.div
                className="w-32 h-32 -mt-8 drop-shadow-2xl"
                whileHover={{ scale: 1.2 }}
              >
                <img
                  src={item?.imageURL}
                  alt=""
                  className="w-full h-full object-contain"
                />
              </motion.div>
              <motion.div
                whileTap={{ scale: 0.75 }}
                className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center cursor-pointer hover:shadow-md -mt-8"
                onClick={() => {
                  if (user) {
                    addToCart(item);
                  } else {
                    dispatch(alertDanger(
                      "<a href='/login' class='underline animate-bounce font-bold'>Đăng nhập</a> để đặt hàng!"
                    ));
                    setTimeout(() => {
                      dispatch(alertNULL());
                    }, 10000);
                  }
                  AnimationImageItemsToCart(item.product_id);
                }}

              >
                <HiPlus className="text-white" />
              </motion.div>
            </div>

            <div className="w-full flex flex-col items-end justify-end -mt-8">
              <p className="text-textColor font-semibold text-base md:text-lg">
                {item?.product_name}
              </p>
              <div className="flex items-center gap-8">
                <p className="text-lg text-headingColor font-semibold">
                  <span className="text-sm text-red-500">VNĐ</span>{" "}
                  {parseFloat(item?.product_price).toLocaleString("en-US")}
                </p>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="w-full flex flex-col items-center justify-center">
          <img src={NotFound} className="h-340" alt="Not Found" />
          <p className="text-xl text-headingColor font-semibold my-2">
            Chưa có sản phẩm. Quay lại sau nhé !
          </p>
        </div>
      )}
    </div>
  );
};

export default RowContainer;
